export const API_CONSTANTS = {
  GET_RADIOLOGISTS: "/report/radiologists",
  DOWNLOAD_RADIOLOGIST_REPORT: "/audit/download/radiologist",
  DOWNLOAD_PATIENTS_SATISFACTION_REPORT: "/feedback/download/report/date-range",
  DOWNLOAD_AUDIT_REGISTRATION_REPORT: '/audit/download/registration',
  UPLOAD_RECEIPT: "receipts/upload"
};